import { useTkv2HandleIconClick } from '@aloft/toolkit-frontend/src/components/ReferenceBar/useTkv2HandleIconClick.ts';

import { selectReferenceBarUI } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { Tkv2ReferenceBarItem } from './Tkv2ReferenceBarItem.tsx';

export const Tkv2ChartItem = () => {
  const { referenceViewOpen, selectedDataSheet } = useAppSelector(selectReferenceBarUI);
  const handleIconClick = useTkv2HandleIconClick();

  const isSelected = selectedDataSheet === 'site-analysis' && referenceViewOpen;

  return (
    <Tkv2ReferenceBarItem
      id="site_analysis"
      label="Site Analysis"
      icon="bar-chart-2"
      isSelected={isSelected}
      onClick={() => handleIconClick('site-analysis')}
    />
  );
};
